module.exports = __webpack_public_path__ + "static/Email-218cb21b1ad3987518470e3f60f3ef82.jpg";